let mTiptapDoc:any;

export function initTiptapDoc(db){
    mTiptapDoc = db.table('tiptapDoc');
}

export function updateTiptapDoc(item){
    return mTiptapDoc.put(item);
}

export function getTiptapDoc(szId){
    return mTiptapDoc.get(szId);
}

export function deleteTiptapDoc(szId:any){
    return mTiptapDoc.delete(szId);
}